import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Link } from 'react-router-dom';
import { ob } from '../../onboardingV2.tokens';

export const Section = styled.section`
    margin-top: 32px;
    text-align: left;
`;

export const Title = styled.h2`
    margin: 0 0 12px;
    font-family: ${ob.font.heading};
    font-size: 18px;
    font-weight: 700;
    color: ${ob.color.brand};
`;

export const List = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0;
    list-style: none;
`;

const rowStyles = ({ highlight }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 64px;
    padding: 12px 12px 12px 14px;
    border: ${highlight ? `1.5px solid ${ob.color.brand}` : `1px solid ${ob.color.borderSubtle}`};
    border-radius: ${ob.radius.lg};
    background: ${ob.color.surface};
    font-family: ${ob.font.body};
    text-align: left;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition:
        border-color ${ob.motion.fast},
        background ${ob.motion.fast};

    ${ob.hover} {
        &:hover:not([aria-disabled='true']) {
            border-color: ${highlight ? ob.color.brand : ob.color.borderHover};
            background: ${ob.color.subtle};
        }
        &:hover:not([aria-disabled='true']) > i:last-of-type {
            transform: translateX(2px);
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }

    &[aria-disabled='true'] {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

export const RowLink = styled(Link, {
    shouldForwardProp: (prop) => prop !== 'highlight',
})`
    ${rowStyles}
`;

export const RowButton = styled.button`
    ${rowStyles}
`;

export const RowIcon = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${({ highlight }) => (highlight ? ob.color.lime : ob.color.lime100)};
    color: ${ob.color.brand};

    i {
        font-size: 22px;
    }
`;

export const RowText = styled.span`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
`;

export const RowTitle = styled.span`
    font-size: 16px;
    line-height: 1.35;
    font-weight: 600;
    color: ${ob.color.brand};
`;

export const RowSubtitle = styled.span`
    font-size: 13px;
    line-height: 1.4;
    color: ${ob.color.muted};
`;

export const Chevron = styled.i`
    flex-shrink: 0;
    font-size: 20px;
    color: ${ob.color.muted};
    transition: transform ${ob.motion.fast};

    ${ob.reducedMotion} {
        transition: none;
    }
`;
